import { getGroups } from "services/apiMiddleware";
import { t } from "../../i18n";

const userGroups = {
  state: {
    isLoading: false,
    error: null,
    items: [],
  },
  reducers: {
    loadStart: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    loadSuccess: (state, groups) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: groups,
      };
    },
    failure: (state, error) => {
      return {
        ...state,
        isLoading: false,
        error,
      };
    },
    setIsLoading: (state, isLoading) => {
      return {
        ...state,
        isLoading,
      };
    },
  },
  effects: (dispatch) => ({
    async init() {
      try {
        dispatch.userGroups.loadStart();
        const data = await getGroups();
        dispatch.userGroups.loadSuccess(data);
      } catch (error) {
        console.error(error);
        dispatch.userGroups.failure(t("groups_load_error", { ns: "common" }));
      }
    },
    setLoading(isLoading) {
      dispatch.userGroups.setIsLoading(isLoading);
    },
  }),
};

export default userGroups;
